// extracted by mini-css-extract-plugin
module.exports = {"item":"List_item__1qYyh","wrap":"List_wrap___X8bM"};